import { render, staticRenderFns } from "./TechPage.vue?vue&type=template&id=5eb90ea2"
import script from "./TechPage.vue?vue&type=script&lang=js"
export * from "./TechPage.vue?vue&type=script&lang=js"
import style0 from "./TechPage.vue?vue&type=style&index=0&id=5eb90ea2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports